<script setup lang="ts">
import { formatAppTitle } from '~/utils/brandTranslation'

const route = useRoute()
const isProtectas = useProtectasBrand()
const { locale } = useI18n()

useHead({
  // Declares the rendered language so browsers do not offer to machine-translate it.
  htmlAttrs: { lang: locale },
  title: () => route.meta.title as string | undefined,
  titleTemplate: title => formatAppTitle(title, isProtectas.value),
})
</script>

<template>
  <VitePwaManifest />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
